import logo from './DOC-Logo-White-Transparent-BG.png'
export const Hero = () => {
    return <div id="general-hero-wrapper" className="content-wrapper clear-fix">
        <figure className="col-3 mar-r-1 doc-logo">
            <a href="https://vadoc.virginia.gov">
                <img width="120" height="120" src={logo} alt="Virginia Department of Corrections Logo" />
            </a>
        </figure>
        <div id="heading-wrapper">
            <a className="section-breadcrumb" href="https://vadoc.virginia.gov/families-friends-of-offenders/visiting-an-offender/">Visitation &nbsp;//</a>
            <h1 id="hero-heading">Visitation Application</h1>
        </div>
    </div>
}